import { ErrorComponent, createFileRoute, type ErrorComponentProps } from '@tanstack/react-router';
import { LegalPagesUnavailable } from '~/components/sections/LegalPagesUnavailable';
import { LocalizedPage, loadLocalizedPage, localizedPageHead } from '~/lib/localized-page';
import { isLegalPagesUnavailableError } from '~/lib/payload';

export const Route = createFileRoute('/$locale/$')({
  loader: ({ params }) =>
    loadLocalizedPage(params.locale, `/${params._splat?.replace(/^\/+|\/+$/gu, '') ?? ''}`),
  head: ({ loaderData }) => localizedPageHead(loaderData),
  errorComponent: LocalizedSplatError,
  component: LocalizedSplatPage,
});

function LocalizedSplatPage() {
  return <LocalizedPage data={Route.useLoaderData()} />;
}

/** Localized `/terms/*` pages load from Payload like `/terms/$`, so show the same outage page. */
function LocalizedSplatError(props: ErrorComponentProps) {
  return isLegalPagesUnavailableError(props.error) ? (
    <LegalPagesUnavailable />
  ) : (
    <ErrorComponent {...props} />
  );
}
